/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profilenotice1Inputs */

const en_settings_profilenotice1 = /** @type {(inputs: Settings_Profilenotice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes or updates to your profile must be done by a member of our team.`)
};

/**
* | output |
* | --- |
* | "Changes or updates to your profile must be done by a member of our team." |
*
* @param {Settings_Profilenotice1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_profilenotice1 = /** @type {((inputs?: Settings_Profilenotice1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profilenotice1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_profilenotice1(inputs)
});
export { settings_profilenotice1 as "settings_profileNotice" }